import type { NotificationRepository } from '@zetyar/data-contracts'
import { createSupabaseNotificationRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webNotificationRepository: NotificationRepository = createSupabaseNotificationRepository(getSupabaseClient())
